import { generateTheme } from '@antlerengineering/components'

const Theme = generateTheme({
  overrides: {
    // Dock main content to left
    MuiContainer: {
      root: {
        marginLeft: 0,
        marginRight: 0,
      },
    },
  },
  props: {
    MuiChip: { variant: 'outlined' },
  },
})

export default Theme
